import { useBotbRAFContext } from "../context";
import { toast } from "react-toastify";
import ToastNotification from "../../../components/ToastNotification/toastNotification";
import CopyLinkIcon from "../../../shared-components/icons/CopyLinkIcon";
import React, { useEffect } from "react";

export const ReferAFriendInvitePopup = (): React.ReactNode => {
  const { rafStatus, showInviteFriendsPopup } = useBotbRAFContext();

  const t: any = {
    title: "Your invite could be their big break",
    desc: "Invite your friends to activate BOTB Pass using your special link:",
    shareLink: "Share",
    shareDetails: "Invitation link: ",
    failSafeCopyUrl: "Your link has been copied",
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <>
      {/*MODAL START*/}
      <div className={`inset-0 z-[1004] size-full bg-black/80  font-jost fixed`}>
        {/*body*/}
        <div
          className={
            "absolute right-0 left-0 bottom-0 w-full rounded-t-2xl bg-white flex items-center flex-col px-4 pt-11 pb-8"
          }>
          <div
            className={"absolute top-3 right-3 rounded-full size-6 flex-center cursor-pointer"}
            onClick={showInviteFriendsPopup}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="#898994"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          {/*content*/}
          <div className={"flex flex-col justify-center lg:max-w-xl lg:my-4 lg:mx-auto h-full lg:h-auto"}>
            {/*title and description*/}
            <div className={"mb-5"}>
              <div className={"text-dark-1 text-base font-medium leading-5.5 mb-2"}>{t.title}</div>
              <div className={"text-gray-1 text-xs font-normal leading-4"}>{t.desc}</div>
            </div>

            {/*share section*/}
            <div className={"w-full flex-center flex-col"}>
              <div className={"flex items-center justify-between gap-2.5 w-full mb-6"}>
                {/*fake input*/}
                <div
                  dir={"rtl"}
                  className={
                    "bg-gray-4 h-12 border border-black/8 pr-[13px] py-[13px] max-w-[calc(100vw-90px)] whitespace-nowrap rounded overflow-hidden grow"
                  }
                  onClick={() => {
                    navigator.clipboard.writeText(`${rafStatus.referralUrl}`);
                  }}>
                  <span className={"text-dark-1 text-base leading-5.5 font-normal"}>{rafStatus.referralUrl}</span>
                </div>
                {/*copy url*/}
                <div className={"size-12 border border-primary rounded"}>
                  <button
                    onClick={() => {
                      toast.info(
                        <ToastNotification message={"Copy to clipboard was successful!"} useInfoIcon={true} />
                      );
                      navigator.clipboard.writeText(`${rafStatus.referralUrl}`);
                    }}
                    className={"size-full flex-center"}>
                    <CopyLinkIcon className={"size-6 shrink-0 text-primary"} />
                  </button>
                </div>
              </div>
              {/*copy link btn*/}
              <div className={"w-full flex-center"}>
                <button
                  className={"theme-btn theme-btn-primary theme-btn-lg w-full uppercase lg:w-60"}
                  type={"button"}
                  onClick={() => {
                    try {
                      navigator.share({
                        text: t.shareDetails,
                        url: `${rafStatus.referralUrl}`,
                      });
                    } catch (e) {
                      toast.warning(<ToastNotification message={t.failSafeCopyUrl} />);
                      navigator.clipboard.writeText(`${rafStatus.referralUrl}`);
                    }
                  }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M8.69922 10.6998L15.2992 7.2998M8.69922 13.2998L15.2992 16.6998M3 12C3 12.7956 3.31607 13.5587 3.87868 14.1213C4.44129 14.6839 5.20435 15 6 15C6.79565 15 7.55871 14.6839 8.12132 14.1213C8.68393 13.5587 9 12.7956 9 12C9 11.2044 8.68393 10.4413 8.12132 9.87868C7.55871 9.31607 6.79565 9 6 9C5.20435 9 4.44129 9.31607 3.87868 9.87868C3.31607 10.4413 3 11.2044 3 12ZM15 6C15 6.79565 15.3161 7.55871 15.8787 8.12132C16.4413 8.68393 17.2044 9 18 9C18.7956 9 19.5587 8.68393 20.1213 8.12132C20.6839 7.55871 21 6.79565 21 6C21 5.20435 20.6839 4.44129 20.1213 3.87868C19.5587 3.31607 18.7956 3 18 3C17.2044 3 16.4413 3.31607 15.8787 3.87868C15.3161 4.44129 15 5.20435 15 6ZM15 18C15 18.7956 15.3161 19.5587 15.8787 20.1213C16.4413 20.6839 17.2044 21 18 21C18.7956 21 19.5587 20.6839 20.1213 20.1213C20.6839 19.5587 21 18.7956 21 18C21 17.2044 20.6839 16.4413 20.1213 15.8787C19.5587 15.3161 18.7956 15 18 15C17.2044 15 16.4413 15.3161 15.8787 15.8787C15.3161 16.4413 15 17.2044 15 18Z"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  {t.shareLink}
                </button>
              </div>
            </div>
          </div>
          {/*content END*/}
        </div>
        {/*body END*/}
      </div>
      {/*MODAL END*/}
    </>
  );
};
